module.exports = __webpack_public_path__ + "static/img/sororas-2.d5b4738.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/sororas-2.jpg
// module id = pNZZ
// module chunks = 1